<h2 mat-dialog-title>New User</h2>
<mat-dialog-content>
  <app-user-form (cancel)="dialogRef.close()"
                 (new-user)="dialogRef.close($event)"></app-user-form>
</mat-dialog-content>